export default "__VITE_ASSET__BGF612Bg__"